var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.opened
        ? _c("div", { staticClass: "modal-mask" }, [
            _c("div", { staticClass: "modal-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "modal-dialog modal-xl modal-dialog-scrollable",
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("Bar chart"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("×")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            on: { click: _vm.showCriterionSelector },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.selectedCriterionName) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            on: { click: _vm.handleToggleLevel },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-regular fa-fw",
                              class: _vm.topLevel
                                ? "fa-square"
                                : "fa-square-check",
                            }),
                            _vm._v(
                              "\n                                Bottom level\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown d-inline-block" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary dropdown-toggle",
                              attrs: { "data-toggle": "dropdown" },
                            },
                            [_vm._v(_vm._s(_vm.theme))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-menu" },
                            [
                              _c("h6", { staticClass: "dropdown-header" }, [
                                _vm._v("Color theme:"),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.themes, function (t) {
                                return _c(
                                  "a",
                                  {
                                    key: t,
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleChangeTheme(t)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(t))]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm._m(0),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("Close")]
                      ),
                    ]),
                  ]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("CriterionSelectorDialog", {
        attrs: { viewModel: _vm.criterionSelectorDialog },
        on: { "confirm-selection": _vm.handleChangeCriterion },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticStyle: { "max-height": "calc(100vh-200px)", overflow: "auto" } },
      [_c("div", { attrs: { id: "Chart-BarChart" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }